import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { OrderTaskApi } from 'api';

export const filterOrderTasks = createAsyncThunk(
  'orderItem/filterOrderTasks',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await OrderTaskApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateOrderTask = createAsyncThunk(
  'orderOption/updateOrderTask',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await OrderTaskApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiOrderTask = createAsyncThunk(
  'orderOption/updateMultiOrderTask',
  async (params: any, { rejectWithValue }) => {
    try {
      const { body } = params;
      const response = await OrderTaskApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiPurchaseOrderTask = createAsyncThunk(
  'orderOption/updateMultiPurchaseOrderTask',
  async (params: any, { rejectWithValue }) => {
    try {
      const { body } = params;
      const response = await OrderTaskApi.updateMultiPurchaseOrder(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  list: Array<any>;
}

const initialState: State = {
  list: [],
};

const orderTaskSlice = createSlice({
  name: 'orderTask',
  initialState,
  reducers: {},
  extraReducers: {},
});

const { reducer: orderTaskReducer } = orderTaskSlice;

export default orderTaskReducer;
